module.exports = __webpack_public_path__ + "img/1966.9ff724dc.gif";